import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { translationChunksConfig } from '@spartacus/assets';
import {
  CmsConfig,
  ConfigModule,
  I18nModule,
  ProductAdapter,
  provideConfig,
  provideDefaultConfig,
} from '@spartacus/core';
import { MediaModule } from '@spartacus/storefront';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { CustomProdPgModule } from '../custom-prod-pg/custom-prod-pg.module';
import { customOccProductConfig } from '../shared/config/custom-prod.config';
import { StockAvailabilityModule } from '../shared/modules/stock-availability/stock-availability.module';
import { CustomOccProductAdapter } from './custom-occ-product.adapter';
import { CustomPdpComponent } from './custom-pdp/custom-pdp.component';
import { OrderCappingComponent } from '../shared/modules/order-capping/order-capping.component';
import { OrderCappingCartBannerComponent } from '../shared/components/order-capping-cart-banner/order-capping-cart-banner.component';

@NgModule({
  declarations: [CustomPdpComponent],

	imports: [
		CommonModule,
		MediaModule,
		I18nModule,
		SlickCarouselModule,
		NgbModule,
		CustomProdPgModule,
		StockAvailabilityModule,
		ConfigModule.withConfig({
			cmsComponents: {
				ProductIntroComponent: {
					component: () =>
						import('./custom-pdp/custom-pdp.component').then(
							(m) => m.CustomPdpComponent
						)
				}
			}
		} as CmsConfig),
		OrderCappingComponent,
		OrderCappingCartBannerComponent
	],
  providers: [
    provideConfig({
      i18n: {
        backend: {
          loadPath: 'i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: translationChunksConfig,
      },
    }),
    {
      provide: ProductAdapter,
      useClass: CustomOccProductAdapter,
    },
    provideDefaultConfig(customOccProductConfig),
  ],
})
export class CustomPdpModule {}
